import { useTranslation } from 'react-i18next';

import CarbonDioxideLabel from 'classes/StandingData/CarbonDioxideLabel/CarbonDioxideLabel';

interface IProps {
	carbonDioxideLabel: CarbonDioxideLabel;
	handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	selectedLanguage: string;
}

const AccessoryCategoryLanguageInput = (props: IProps) => {
	const { t } = useTranslation();

	const renderContent = () => {
		return (
			<>
				<div className="row mt-2">
					<div className="col-12 mt-2">
						<div className="row mb-3">
							<label>{t('_general:DESCRIPTION')}</label>
							<div>
								<input
									value={
										props.carbonDioxideLabel.labelTranslations[
											props.selectedLanguage
										] || ''
									}
									type="text"
									onChange={props.handleValueChange}
									className="form-control"
									name="labelTranslations"
									error-key={'LabelTranslations'}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default AccessoryCategoryLanguageInput;
